import React from 'react';

const NoAPIManagement: React.FC = () => {
  return (
    <div className='no-api-container'>
      <div className='meter-head'>
        <h1>API Plans</h1>
      </div>
      <div className='no-api-body'>
        <div className='no-api-msg-container'>
          <div className='no-api-avatar'>
            <svg xmlns='http://www.w3.org/2000/svg' width='36' height='36' viewBox='0 0 36 36' fill='none'>
              <g clipPath='url(#clip0_4196_13482)'>
                <path d='M0 18C0 8.05888 8.05888 0 18 0C27.9411 0 36 8.05888 36 18C36 27.9411 27.9411 36 18 36C8.05888 36 0 27.9411 0 18Z' fill='#FDB022' fillOpacity='0.15'/>
                <path d='M0.25 18C0.25 8.19695 8.19695 0.25 18 0.25C27.8031 0.25 35.75 8.19695 35.75 18C35.75 27.8031 27.8031 35.75 18 35.75C8.19695 35.75 0.25 27.8031 0.25 18Z' stroke='#EFF1F6' strokeWidth='0.5'/>
                <g clipPath='url(#clip1_4196_13482)'>
                  <path d='M12.375 25.6875V21.9375M12.375 14.4375V10.6875M10.5 12.5625H14.25M10.5 23.8125H14.25M18.75 11.4375L17.4494 14.8191C17.2379 15.3691 17.1321 15.644 16.9676 15.8753C16.8219 16.0803 16.6428 16.2594 16.4378 16.4051C16.2065 16.5696 15.9316 16.6754 15.3816 16.8869L12 18.1875L15.3816 19.4881C15.9316 19.6996 16.2065 19.8054 16.4378 19.9699C16.6428 20.1156 16.8219 20.2947 16.9676 20.4997C17.1321 20.731 17.2379 21.0059 17.4494 21.5559L18.75 24.9375L20.0506 21.5559C20.2621 21.0059 20.3679 20.731 20.5324 20.4997C20.6781 20.2947 20.8572 20.1156 21.0622 19.9699C21.2935 19.8054 21.5684 19.6996 22.1184 19.4881L25.5 18.1875L22.1184 16.8869C21.5684 16.6754 21.2935 16.5696 21.0622 16.4051C20.8572 16.2594 20.6781 16.0803 20.5324 15.8753C20.3679 15.644 20.2621 15.3691 20.0506 14.8191L18.75 11.4375Z' stroke='#FDB022' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round'/>
                </g>
              </g>
              <path d='M0.5 18C0.5 8.33502 8.33502 0.5 18 0.5C27.665 0.5 35.5 8.33502 35.5 18C35.5 27.665 27.665 35.5 18 35.5C8.33502 35.5 0.5 27.665 0.5 18Z' stroke='#FDB022'/>
              <defs>
                <clipPath id='clip0_4196_13482'>
                  <path d='M0 18C0 8.05888 8.05888 0 18 0C27.9411 0 36 8.05888 36 18C36 27.9411 27.9411 36 18 36C8.05888 36 0 27.9411 0 18Z' fill='white'/>
                </clipPath>
                <clipPath id='clip1_4196_13482'>
                  <rect width='18' height='18' fill='white' transform='translate(9 9.1875)'/>
                </clipPath>
              </defs>
            </svg>
          </div>
          <div className='no-api-msg-text-body'>
            <div className='no-api-msg-text-style'>
              This feature is accessible only with an Enterprise plan. Upgrade your account plan to access API plans.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NoAPIManagement;
